module.exports = __webpack_public_path__ + "img/kin3.7a8cf1c2.jpg";